import { PlanogramProductSchema } from "@labeling-tools/api/atlas";
import { cn } from "../../../utils/plano-related.utils";
import {
  getLabelDimension,
  PlanoDimension,
} from "../../../utils/plano-related.utils";
import Color from "color";
import ColorHash from "color-hash";
import {
  activeLabelBoxWidth,
  useActivePlanoProductInfoStore,
} from "../../use-active-plano-product-info-store";

const colorHash = new ColorHash({ saturation: 0.9 });

interface Props {
  planoDimension: PlanoDimension;
  planogramProduct: PlanogramProductSchema;
  isSelected: boolean;
  callback?: (product_id: string | null) => void;
}

export const OneLabelBox = (props: Props) => {
  const { planoDimension, planogramProduct, isSelected } = props;

  const labelDimension = getLabelDimension(planogramProduct);

  const left =
    ((labelDimension.x0 - planoDimension.x0) / planoDimension.w) * 100 + "%";
  const top =
    ((labelDimension.y0 - planoDimension.y0) / planoDimension.h) * 100 + "%";
  const width = (labelDimension.w / planoDimension.w) * 100 + "%";
  const height = (labelDimension.h / planoDimension.h) * 100 + "%";
  const borderColor = isSelected ? "red" : "transparent";

  const bgColor = colorHash.hex(planogramProduct.description);
  const backgroundColor = Color(bgColor).alpha(0.1).toString();
  const bgColorHover = Color(bgColor).alpha(0.3).toString();

  return (
    <div
      className={cn(`absolute cursor-pointer border`)}
      style={{
        top,
        left,
        width,
        height,
        borderColor,
        backgroundColor,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = bgColorHover;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = backgroundColor;
      }}
      onMouseDown={() => {
        const { setMouseDownUuid } = useActivePlanoProductInfoStore.getState();
        setMouseDownUuid(planogramProduct.id);
      }}
      onClick={(e) => {
        const {
          setActiveLabelBoxInfo,
          productBoxInfo: labelBoxInfo,
          setMouseDownUuid,
          mouseDownUuid,
        } = useActivePlanoProductInfoStore.getState();
        const isClickAgain =
          mouseDownUuid === labelBoxInfo.planogram_product_id;
        setMouseDownUuid("");

        if (isClickAgain) {
          setActiveLabelBoxInfo({
            left: 0,
            top: 0,
            planogram_product_id: "",
            product_id: "",
          });
        } else {
          const rect = e.currentTarget.getBoundingClientRect();

          const parentEl = document.getElementById(
            "planogram-view-container",
          ) as HTMLDivElement | null;
          if (!parentEl) return;

          const parentRect = parentEl.getBoundingClientRect();

          const hasEnoughSpaceOnRight =
            rect.right + activeLabelBoxWidth < window.innerWidth;

          setActiveLabelBoxInfo({
            top: Math.max(0, rect.top - parentRect.top),
            left: hasEnoughSpaceOnRight
              ? rect.right - parentRect.left + 4
              : rect.left - parentRect.left - activeLabelBoxWidth + 20 - 4,
            planogram_product_id: planogramProduct.id,
            product_id: planogramProduct.product_id,
          });
        }
      }}
    >
      {planogramProduct.image_url ? (
        <img
          className="size-full object-contain"
          src={planogramProduct.image_url}
        />
      ) : (
        <div className="size-full border-2 border-dashed border-red-500" />
      )}
    </div>
  );
};
